import React, {Component} from 'react';
import { getUser, getUserName, removeUserSession } from '../utils/commons';
import AurusLogo from '../images/aurus.jpg';
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";

import Typography from "@material-ui/core/Typography";

export class Home extends Component {
    constructor(props) {
        super(props);

        this.state={
            isLoading: true,
            error: null,
            codAbogado: '',
            razonSocial: '',
            abogado: ''
        }
        console.log('HOME - constructor', this.state.abogado);
    }

    render () {
        //const user = getUser(); // estas dos lineas daban el error anterior
        //const userName = getUserName();
        return (
            <div className="mt-5 dflex justify-content-left">
                <h3>Esta es la página principal.
                    
                </h3>
                <div id="logo">
                
                   <img src={AurusLogo} alt={"logo"} width="100%" height="200" />

                </div>
            </div>    
        )
    }
}